import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

export const RegistrationGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.company$.pipe(
    map((company) => {
      if (!company?.registrationCompleted) return router.parseUrl('/welcome');
      // WKO companies created before the WKO welcome wizard existed have
      // registrationCompleted=true (from the legacy auto-create) but no
      // WKO-specific data. Send them through /welcome once so the wizard
      // captures industry/companySize/personal data and tags the Company
      // with originType=wko + wkoOnboardingCompleted=true.
      if (company.originType === 'wko' && !company.wkoOnboardingCompleted) {
        return router.parseUrl('/welcome');
      }
      if (!company?.wasticsAgbAccepted) return router.parseUrl('/accept-agb');

      return true;
    })
  );
};
